// String Constants that describe the `displaySpecialOffer` field
const IS_JL_EXCLUSIVE = 'exclusive to john lewis & partners';
const IS_PRICE_MATCH = 'price match';
const IS_REDUCED_TO_CLEAR = 'reduced to clear';

export const isJLExclusive = (specialOfferMessage) =>
  specialOfferMessage
    ? specialOfferMessage.toLowerCase() === IS_JL_EXCLUSIVE
    : false;

export const isPriceMatch = (specialOfferMessage) =>
  specialOfferMessage
    ? specialOfferMessage.toLowerCase() === IS_PRICE_MATCH
    : false;

export const isReducedToClear = (specialOfferMessage) =>
  specialOfferMessage
    ? specialOfferMessage.toLowerCase() === IS_REDUCED_TO_CLEAR
    : false;
